<div class="rts-trusted-client rts-section-gapBottom">
  <div class="container">
    <div class="row">
      <div class="col-12">
        @if(!bronze){
        <div class="title-area-client text-center">
          <p class="client-title">{{ "MENU.SPONSOR" | translate }}</p>
        </div>
        }
        @else if(bronze && sponsers().length > 0) {
        <div class="title-area-client text-center mt-5">
          <p class="client-title">{{ "MENU.BRONZE_SPONSOR" | translate }}</p>
        </div>
        }
      </div>
    </div>
    <div *ngIf="sponsers().length > 0" appSwiper [swiperOptions]="swiperOptions()" class="mySwiperh1_client">
      <div class="swiper-wrapper">
        @for (sponser of sponsers(); track $index) {
        <!-- @if(sponser.sponsorType !=='Bronze'){ -->
        <div class="swiper-slide">
          @if(sponser.sponsorType ==='Gold'){
          <a [routerLink]="['/sponser-details',sponser.id]">
            <div class="image-container">
              <img [src]="sponser.image.path | imageUrl" [alt]="sponser.image.originalName">
              <div class="image-overlay">{{ sponser.nameAr }}</div>
            </div>
          </a>
          }
          @else if (sponser.sponsorType ==='Silver'){
          <a target="_blank" [href]="sponser?.websiteUrl">
            <div class="image-container">
              <img [src]="sponser.image.path | imageUrl" [alt]="sponser.image.originalName">
              <div class="image-overlay">{{ sponser.nameAr }}</div>
            </div>
          </a>
          }
          @else {
          <div class="image-container sponser_bronze">
            <img [src]="sponser.image.path | imageUrl" [alt]="sponser.image.originalName">
            <div class="image-overlay">{{ sponser.nameAr }}</div>
          </div>
          }
        </div>
        <!-- } -->
        }
      </div>
      <div class="swiper-pagination"></div>

      <!-- Navigation buttons -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</div>